import { format, parse } from 'date-fns';
import { PRICELINE_DATE_FORMAT } from '../../constants/dates';
/** @public */
var formatDate = function (dateStr, dateFormat) {
    if (dateFormat === void 0) { dateFormat = 'MM/dd/yyyy'; }
    if (dateStr && dateStr.length > 0) {
        return format(parse(dateStr, PRICELINE_DATE_FORMAT, new Date()), dateFormat);
    }
    return '';
};
export default formatDate;
//# sourceMappingURL=formatDate.js.map